import React from 'react'

import { useStateValue } from '../HOC/StateProvider'
import { DispatchTypes } from '../../store/reducer'
import './CheckoutProduct.scss'

const { REMOVE_FROM_BASKET } = DispatchTypes

interface ICheckout {
  id: string
  image: string
  title: string
  price: number
  rating: number
  hideButton?: any
}

const Checkout = ({ id, image, title, price, rating, hideButton }: ICheckout) => {
  const { state, dispatch } = useStateValue()
  const { basket, user } = state

  const removeFromBasket = () => {
    // remove the item from the basket
    dispatch({ type: REMOVE_FROM_BASKET, id })
  }

  return (
    <div className='checkoutProduct'>
      <img className='checkoutProduct__image' src={image} />

      <div className='checkoutProduct__info'>
        <p className='checkoutProduct__title'>{title}</p>
        <p className='checkoutProduct__price'>
          <small>$</small>
          <strong>{price}</strong>
        </p>
        <div className='checkoutProduct__rating'>
          {Array(rating)
            .fill(null)
            .map((_, i) => (
              <p>⭐</p>
            ))}
        </div>
        {!hideButton && <button onClick={removeFromBasket}>Remove from Basket</button>}
      </div>
    </div>
  )
}

export default Checkout
